<template>
  <div>

      <!-- <pre>{{environment}}</pre> -->
    <h3>Environment</h3>
    <v-list>
        <v-divider />
        <div v-for="(setting,s) in environment" :key="s">
            <v-list-item>
                <v-list-item-content>
                    <v-list-item-title>{{s}}</v-list-item-title>
                    <v-list-item-subtitle>{{setting}}</v-list-item-subtitle>
                </v-list-item-content>
            </v-list-item>
            <v-divider />
        </div>
    </v-list>

    <h3>Build</h3>
    <v-list>
        <v-divider />
        <div v-for="(setting,s) in buildSettings" :key="s">
            <v-list-item>
                <v-list-item-content :class="{'d-flex flex-nowrap' : $vuetify.breakpoint.smAndUp}">
                    <v-list-item-title>{{s}}</v-list-item-title>
                    <v-list-item-subtitle>{{setting}}</v-list-item-subtitle>
                </v-list-item-content>
            </v-list-item>
            <v-divider />
        </div>
    </v-list>

    <pre>{{appConfig}}</pre>

  </div>
</template>

<script>


import environmentConfig from "@/_config/environment"
import globalAppConfig from "@/app.config.global"

export default {
  name: 'About',
  async created()
  {
      this.environment = await environmentConfig.getSettings();
  },
  data() {
    return {
        environment : null,
    }
  },
  computed : {
      appConfig()
      {
          return globalAppConfig;
      },
      buildSettings()
      {
          return {
              "build" : process.env.NODE_ENV,
          }
      }
  },
  methods : {}
  
}

</script>
<style scoped type="scss">
.tag
{
    margin-right:2px !important;
}
</style>
